import { render, staticRenderFns } from "./prize.vue?vue&type=template&id=0e7635c8"
import script from "./prize.vue?vue&type=script&lang=ts"
export * from "./prize.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-co_fdc8552a8ede636d403bf9928f1c7af2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports